// 统一导出话题和可见范围常量
export const TOPIC_OPTIONS = [
  { label: '找队友', value: '找队友' },
  { label: '创意提案', value: '创意提案' },
  { label: '职业自荐', value: '职业自荐' },
  { label: '技术官', value: '技术官' },
  { label: '产品官', value: '产品官' },
  { label: '运营官', value: '运营官' },
  { label: '火星智慧行者场景', value: '火星智慧行者场景' },
  { label: '月球智能家园场景', value: '月球智能家园场景' },
  { label: '水星智联社区场景', value: '水星智联社区场景' },
  { label: '金星智享课堂场景', value: '金星智享课堂场景' },
  { label: '木卫二城市脉搏场景', value: '木卫二城市脉搏场景' },
  { label: '土卫六星际集市场景', value: '土卫六星际集市场景' },
  { label: '新星发掘场景', value: '新星发掘场景' },
];

// 统一导出话题和可见范围常量
export const PROPOSAL_TOPIC_OPTIONS = [
  { label: '提案', value: 'ai_competition' },
  {
    label: '燕缘·滴水湖大学生AI+国际创业大赛模板',
    value: 'ai_competition_model',
  },
  // { label: '找队友', value: '找队友' },
  // { label: '创意提案', value: '创意提案' },
  // { label: '职业自荐', value: '职业自荐' },
  // { label: '技术官', value: '技术官' },
  // { label: '产品官', value: '产品官' },
  // { label: '运营官', value: '运营官' },
  { label: '火星智慧行者场景', value: '火星智慧行者场景' },
  { label: '月球智能家园场景', value: '月球智能家园场景' },
  { label: '水星智联社区场景', value: '水星智联社区场景' },
  { label: '金星智享课堂场景', value: '金星智享课堂场景' },
  { label: '木卫二城市脉搏场景', value: '木卫二城市脉搏场景' },
  { label: '土卫六星际集市场景', value: '土卫六星际集市场景' },
  { label: '新星发掘场景', value: '新星发掘场景' },
];

export const VISIBLE_OPTIONS = [
  { label: '全部可见', value: 'all' },
  // { label: '我的粉丝可见', value: 'fans' },
  // { label: '互相关注可见', value: 'mutual' },
  { label: '仅自己可见', value: 'self' },
];

export const MASK_IMAGE_ENUM = {
  SUBTRACT_1: '/assets/subtract-1-mask.svg',
  SUBTRACT_2: '/assets/subtract-2-mask.svg',
  SUBTRACT_3: '/assets/subtract-3-mask.svg',
  SUBTRACT_4: '/assets/subtract-4-mask.svg',
  SUBTRACT_5: '/assets/subtract-5-mask.svg',
};

export const CARD_BG_ENUM = {
  YELLOW: '#F5CD43',
  PINK: '#F197BD',
  PURPLE: '#CA8EFA',
  BLUE: '#6B9BF8',
  LAVENDER: '#AAABF0',
  GREEN: '#BBF2A8',
  LIME: '#E6F67C',
  RED: '#EE9092',
};

export const MASK_IMAGES = Object.values(MASK_IMAGE_ENUM);
export const CARD_BG_GRADIENTS = Object.values(CARD_BG_ENUM);

// 社交媒体平台枚举
export const MEDIA_ENUM = {
  WECHAT: 'wechat',
  WEIBO: 'weibo',
  FIGMA: 'figma',
  ZHIHU: 'zhihu',
  REDNOTE: 'rednote',
  GITHUB: 'github',
  TIKTOK: 'tiktok',
  OFFICAL_ACCOUNT: 'offical_account',
  BILIBILI: 'bilibili',
  JIKE: 'jike',
  CUSTOM: 'custom',
};

// 社交平台icon映射（仅key，不含JSX，UI层import后映射）
export const SOCIAL_ICON_MAP = {
  [MEDIA_ENUM.WECHAT]: 'wechat',
  [MEDIA_ENUM.WEIBO]: 'weibo',
  [MEDIA_ENUM.FIGMA]: 'figma',
  [MEDIA_ENUM.ZHIHU]: 'zhihu',
  [MEDIA_ENUM.REDNOTE]: 'rednote',
  [MEDIA_ENUM.GITHUB]: 'github',
  [MEDIA_ENUM.TIKTOK]: 'tiktok',
  [MEDIA_ENUM.OFFICAL_ACCOUNT]: 'offical_account',
  [MEDIA_ENUM.BILIBILI]: 'bilibili',
  [MEDIA_ENUM.JIKE]: 'jike',
  [MEDIA_ENUM.CUSTOM]: 'custom',
};

// 分享二维码参数类型
export const SHARE_SCENE_TYPE = {
  PERSONAL: 'personal', // 个人详情页
  FRIEND: 'friend', // 找队友详情页
  PROPOSAL: 'proposal', // 提案广场详情页
};

export const SHARE_QR_CONFIG = {
  [SHARE_SCENE_TYPE.PERSONAL]: {
    page: 'pages/person/viewPerson/viewPerson',
    getScene: (userId) => `id=${userId}`,
  },
  [SHARE_SCENE_TYPE.FRIEND]: {
    page: 'pages/post/detail/detail',
    getScene: (postId) => `id=${postId}`,
  },
  [SHARE_SCENE_TYPE.PROPOSAL]: {
    page: 'pages/post/detail/detail',
    getScene: (proposalId) => `proid=${proposalId}`,
  },
  [SHARE_SCENE_TYPE.WORKSPACE]: {
    page: 'pages/workspace/detail',
    getScene: (workspaceId) => `id=${workspaceId}`,
  },
};

// 个人信息页/标签编辑相关选项
export const CAREER_OPTIONS = ['技术官', '运营官', '产品官','顾问','志愿者','共创者'];

// 职业对应的颜色映射
export const CAREER_COLOR_MAP = {
  '技术官': 'bg-blue-500 text-white',
  '运营官': 'bg-green-500 text-white',
  '产品官': 'bg-purple-500 text-white',
  '顾问': 'bg-yellow-500 text-white',
  '志愿者': 'bg-pink-500 text-white',
  '共创者': 'bg-indigo-500 text-white'
};
export const TRACK_OPTIONS = [
  '火星智慧行者场景',
  '月球智能家园场景',
  '水星智联社区场景',
  '金星智享课堂场景',
  '木卫二城市脉搏场景',
  '土卫六星际集市场景',
  '新星发掘场景',
];

export const PROPOSAL_TOPIC_OPTIONS_NO_TEMPLATE = PROPOSAL_TOPIC_OPTIONS.filter((opt) => opt.value !== 'ai_competition' && opt.value !== 'ai_competition_model');

// 团队招募状态选项
export const RECRUITING_STATUS_OPTIONS = [
  { label: '团队招募中', value: 'recruiting' },
  { label: '团队已锁定', value: 'locked' },
];

// 缺少角色选项
export const MISSING_ROLES_OPTIONS = [
  { label: '缺少产品官', value: 'product_manager' },
  { label: '缺少技术官', value: 'tech_lead' },
  { label: '缺少运营官', value: 'operation_manager' },
];

// 成员角色选项
export const MEMBER_ROLE_OPTIONS = [
  { label: '队长', value: 'captain' },
  { label: '产品官', value: 'product_manager' },
  { label: '技术官', value: 'tech_lead' },
  { label: '运营官', value: 'operation_manager' },
  // { label: '队员', value: 'member' },
];

export const GRADE_OPTIONS = ['专科', '本科', '硕士', '博士'];
export const MAJOR_OPTIONS = [
  '哲学',
  '经济学',
  '法学',
  '教育学',
  '文学',
  '理学',
  '工学',
  '农学',
  '医学',
  '管理学',
  '艺术学',
  '历史学',
  '其他',
];

// 筛选字段选项
export const FILTER_FIELD_OPTIONS = [
  { label: '话题', value: 'tags' },
  // { label: '创建者', value: 'create_by' }
];

// 话题选项（直接复用TOPIC_OPTIONS）
export const FILTER_TOPIC_OPTIONS = TOPIC_OPTIONS;

// 星球背景图映射 - 使用外部工具函数
export { PLANET_BACKGROUND_MAP, DEFAULT_PLANET_BACKGROUND, getPlanetBackground } from './planetBackgrounds';
